import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    MenuItem,
    IconButton,
    Typography,
    Select,
    Chip,
} from "@mui/material";

import { Visibility, Delete } from "@mui/icons-material";
import Edit from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";
import deleteConfirm from "./deleteDepartment";

const API_DEPTS = "https://api.hr-ebnhaian.cloud/api/v1/departments";
const API_CENTERS = "https://api.hr-ebnhaian.cloud/api/v1/centers";

function DepartmentList() {
    const [departments, setDepartments] = useState([]);
    const [centers, setCenters] = useState([]);

    const [centerFilter, setCenterFilter] = useState(""); // ✅ فلتر حسب المركز
    const [searchTerm, setSearchTerm] = useState("");

    const navigate = useNavigate();

    /* =========================
       FETCH DEPARTMENTS
    ========================= */
    const fetchDepartments = () => {
        axios
            .get(API_DEPTS, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                setDepartments(res.data.data || []);
            })
            .catch((err) => {
                console.error("Error fetching departments:", err);
            });
    };

    /* =========================
       FETCH CENTERS (للـ Filter)
    ========================= */
    const fetchCenters = () => {
        axios
            .get(API_CENTERS, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                setCenters(res.data.data || []);
            })
            .catch((err) => {
                console.error("Error fetching centers:", err);
            });
    };

    useEffect(() => {
        fetchDepartments();
        fetchCenters();
    }, []);

    /* =========================
       FILTER
    ========================= */
    const filteredDepartments = departments.filter((dep) => {
        const depName = (dep.name || "").toLowerCase();
        const centerName = (dep.center?.name || "").toLowerCase();

        return (
            (!centerFilter || dep.center?._id === centerFilter) &&
            (depName.includes(searchTerm.toLowerCase()) ||
                centerName.includes(searchTerm.toLowerCase()))
        );
    });

    return (
        <Box p={3}>
            <Typography variant="h5" mb={2}>
                Departments
            </Typography>

            {/* ACTION BAR */}
            <Box display="flex" alignItems="center" gap={2} mb={2}>
                <Select
                    value={centerFilter}
                    onChange={(e) => setCenterFilter(e.target.value)}
                    displayEmpty
                    size="small"
                >
                    <MenuItem value="">All Centers</MenuItem>
                    {centers.map((c) => (
                        <MenuItem key={c._id} value={c._id}>
                            {c.name} {c.code ? `(${c.code})` : ""}
                        </MenuItem>
                    ))}
                </Select>

                <TextField
                    size="small"
                    label="Search (department/center)"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />

                <Button variant="contained" onClick={() => navigate("/departments/add")}>
                    Add Department
                </Button>
            </Box>

            {/* TABLE */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: "#1976d2" }}>
                        <TableRow>
                            <TableCell sx={{ color: "white" }}>
                                <input type="checkbox" />
                            </TableCell>

                            <TableCell sx={{ color: "white" }}>Department</TableCell>
                            <TableCell sx={{ color: "white" }}>Center</TableCell>
                            <TableCell sx={{ color: "white" }}>Created</TableCell>

                            <TableCell sx={{ color: "white" }}>Log</TableCell>
                            <TableCell sx={{ color: "white" }}>Details</TableCell>
                            <TableCell sx={{ color: "white" }}>Edit</TableCell>
                            <TableCell sx={{ color: "white" }}>Delete</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filteredDepartments.map((dep) => (
                            <TableRow key={dep._id}>
                                <TableCell>
                                    <input type="checkbox" />
                                </TableCell>

                                <TableCell>{dep.name}</TableCell>

                                <TableCell>
                                    {dep.center?.name ? (
                                        <Chip
                                            label={dep.center.name}
                                            size="small"
                                            variant="outlined"
                                        />
                                    ) : (
                                        "-"
                                    )}
                                </TableCell>

                                <TableCell>
                                    {dep.createdAt ? new Date(dep.createdAt).toLocaleDateString() : "-"}
                                </TableCell>

                                {/* Log */}
                                <TableCell>
                                    <IconButton>
                                        <Visibility />
                                    </IconButton>
                                </TableCell>

                                {/* Details */}
                                <TableCell>
                                    <IconButton onClick={() => navigate(`/departments/${dep._id}`)}>
                                        📁
                                    </IconButton>
                                </TableCell>

                                {/* Edit */}
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        onClick={() => navigate(`/departments/${dep._id}/edit`)}
                                    >
                                        <Edit />
                                    </IconButton>
                                </TableCell>

                                {/* Delete */}
                                <TableCell>
                                    <IconButton
                                        color="error"
                                        onClick={() =>
                                            deleteConfirm(`${API_DEPTS}/${dep._id}`, fetchDepartments)
                                        }
                                    >
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}

                        {filteredDepartments.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={8} align="center">
                                    No departments found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default DepartmentList;